import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UMAMI_SCRIPT_ID = 'umami-analytics';
const UMAMI_SRC = 'https://umami.vor2.com/script.js';
const UMAMI_WEBSITE_ID = '2907a045-ecba-4e51-b751-6e0683fc3231';

function isAdminPath(pathname: string): boolean {
  return pathname.startsWith('/admin');
}

const UmamiAnalytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const existing = document.getElementById(UMAMI_SCRIPT_ID);

    if (isAdminPath(pathname)) {
      existing?.remove();
      delete (window as Window & { umami?: unknown }).umami;
      return;
    }

    if (existing) return;

    const script = document.createElement('script');
    script.id = UMAMI_SCRIPT_ID;
    script.defer = true;
    script.src = UMAMI_SRC;
    script.setAttribute('data-website-id', UMAMI_WEBSITE_ID);
    document.head.appendChild(script);
  }, [pathname]);

  return null;
};

export default UmamiAnalytics;
